export class SecretQuestion {
    code: string
    question: string

    constructor(code: string, question: string) {
        this.code = code
        this.question = question
    }
}